'use client';

import { c as _c } from "react/compiler-runtime";
import { useWebView } from '../../hooks/useWebView';
import { MedalliaLoaderV2 } from './medallia-loader-v2';
export const MedalliaV2 = () => {
  const $ = _c(1);
  const isWebView = useWebView();
  if (isWebView) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MedalliaLoaderV2 />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};